import React from "react"
import styled from "styled-components"
import {
  useCaseData,
  industryData,
} from "../../data/pageSections/home/useCases"
import H2 from "../typography/H2"
import H3 from "../typography/H3"
import P from "../typography/P"
import Section from "./Section"

const IdealUseCases = () => (
  <IdealDescriptionWrapper>
    <Section
      tint="#f1f5f8"
      clipPath="polygon(100% 0, 100% calc(100% - 6vw), 51% 100%, 0 calc(100% - 6vw), 0 0)"
    >
      <StyledH2>MindMe is ideal for these Use Cases and Industries</StyledH2>
    </Section>
    <CustomSection className="use-case-wrapper">
      <SectionContainer>
        <H3>Use Cases</H3>
        <UseCaseWrapper className="margin-bottom-30">
          {useCaseData.map(({ useCases }) => (
            <UseCaseBackground>
              {useCases.map(({ useCase }) => (
                <P marginBottom={5}>{useCase}</P>
              ))}
            </UseCaseBackground>
          ))}
        </UseCaseWrapper>
      </SectionContainer>
    </CustomSection>
    <CustomSection className="industries-wrapper">
      <SectionContainer>
        <H3>Industries</H3>
        <UseCaseWrapper>
          {industryData.map(({ useCases }) => (
            <UseCaseBackground>
              {useCases.map(({ useCase }) => (
                <P marginBottom={5}>{useCase}</P>
              ))}
            </UseCaseBackground>
          ))}
        </UseCaseWrapper>
      </SectionContainer>{" "}
    </CustomSection>
  </IdealDescriptionWrapper>
)

export default IdealUseCases

const UseCaseWrapper = styled.div`
  ${({ theme }) => theme.se`
    display: flex;
    flex-direction: column;
    width: 100%;
    &.margin-bottom-30{
      margin-bottom: 30px;
    }
  `}

  ${({ theme }) => theme.tablet`
    justify-content: space-between;
    flex-direction: row;
    margin: auto;
  `}
`
const UseCaseBackground = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.se`
    
    padding: 30px 0;
    align-items: center;
  justify-content: flex-start;
    padding-bottom: 0px;
  `}

  ${({ theme }) => theme.desktop`
    margin-bottom: 15px;
  `};
`

const CustomSection = styled(Section)`
  ${({ theme }) => theme.se`
   width: 100%;
   &.use-case-wrapper{
     padding-bottom: 0px;
     padding-top: 50px;
     max-width: 1400px;
     margin: 0 auto;
   }
   &.industries-wrapper{
     padding-top: 0px;
     max-width: 1400px;
     margin: 0 auto;
   }
  `}

  ${({ theme }) => theme.tablet`
   flex-direction: row;
   align-items: flex-start;
  `};
`

const SectionContainer = styled.div`
  ${({ theme }) => theme.se`
   display: flex;
   flex-direction: column;
   align-items: center;
   width: 100%;
  `}

  ${({ theme }) => theme.tablet`
   align-items: center;
   width: 48%;
  justify-content: space-between;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  `}

  ${({ theme }) => theme.desktop`
    justify-content: space-between;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  `}
`
const StyledH2 = styled(H2)`
  text-align: center;
`
const IdealDescriptionWrapper = styled.div`
  ${({ theme }) => theme.se`
  display: none;  
  `}
  ${({ theme }) => theme.tablet`
   display: block;
  `}
`
